export default "__VITE_ASSET__B_2Qpv59__"